// extracted by mini-css-extract-plugin
export default {"document-item":"EmailComposition_document-item__bYL2M","vertical-bar":"EmailComposition_vertical-bar__jIpVx"};